import {
  CopyButton,
  CopiedLabel,
  StyledInvitePopup,
  StyledInvitePopupContent,
  StyledInviteInputControls,
  StyledInviteButtonWrapper
} from './InvitePopup.styled';
import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';
import { LoadingSpinner, TextInput, AppModal, IconButton } from '../';
import { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../providers/AppContext';
import { getInviteInfo } from '../../providers/BasejumpApiProvider';
import { useTokenAuth } from '../../hooks';

const InvitePopup = () => {
  const { basejumpToken } = useTokenAuth();
  const { setShowInvitePopup, setErrorData } = useContext(AppContext);
  const [copied, setCopied] = useState(false);
  const [inviteUrl, setInviteUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const loadInvite = async () => {
    try {
      const inviteData = await getInviteInfo(basejumpToken);
      setInviteUrl(inviteData.url);
      setIsLoading(false);
    } catch (error) {
      setErrorData({ title: 'Error', description: 'Failed to generate invite link!' });
    }
  };

  const onClickCopy = async () => {
    await navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    if (basejumpToken) {
      loadInvite();
    }
  }, [basejumpToken]);

  return (
    <AppModal>
      <StyledInvitePopup>
        <PopupHeader>
          <PopupHeaderStart/>
            <PopupHeaderTitle>
              Invite your friends
            </PopupHeaderTitle>
          <PopupHeaderEnd />
        </PopupHeader>
        <StyledInvitePopupContent>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <StyledInviteInputControls>
              <TextInput disabled={true} initText={inviteUrl} />
              <CopyButton onClick={onClickCopy} src='/assets/copy.svg'/>
            </StyledInviteInputControls>
          )}
          <CopiedLabel>{copied ? 'Copied to Clipboard!' : ''}</CopiedLabel>
          <StyledInviteButtonWrapper>
            <IconButton onClick={() => setShowInvitePopup(false)}>OK</IconButton>
          </StyledInviteButtonWrapper>
        </StyledInvitePopupContent>
      </StyledInvitePopup>
    </AppModal>
  );
};

export default InvitePopup;
